export default {"src":"/_next/static/media/AEO.f7886779.svg","height":18,"width":18};